// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const ThumbsDownFilledIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'thumbs-down-filled'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M15.8998 16.2754L12.81 22.4473C12.6385 22.7897 12.2857 23.0047 11.9027 23C11.2808 22.9923 10.6684 22.8439 10.1117 22.5664C9.55486 22.2888 9.06754 21.8887 8.68691 21.3965C8.30635 20.9043 8.04205 20.3324 7.91348 19.7236C7.78493 19.1148 7.79557 18.484 7.94473 17.8799L8.64395 15H4.08535C3.61968 15 3.16008 14.8918 2.74356 14.6836C2.32702 14.4753 1.96439 14.1723 1.68496 13.7998C1.40576 13.4274 1.21752 12.995 1.13418 12.5371C1.05087 12.0789 1.07509 11.6072 1.20547 11.1602L3.53555 3.16016L3.6127 2.92969C3.81411 2.40229 4.16136 1.94031 4.61563 1.59961C5.13482 1.21038 5.76652 1 6.41543 1H15.8998V16.2754Z"
          fill="currentColor"
        />
        <path
          d="M19.9154 1C20.711 1.00007 21.474 1.31636 22.0365 1.87891C22.599 2.4415 22.9154 3.20442 22.9154 4V12C22.9154 12.7956 22.599 13.5585 22.0365 14.1211C21.474 14.6836 20.711 14.9999 19.9154 15H17.9145V1H19.9154Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
ThumbsDownFilledIcon.displayName = 'ThumbsDownFilledIcon'
export { ThumbsDownFilledIcon }
